/* istanbul ignore file */
import Box from '@mui/material/Box';
import { FormSection } from 'framework/ui/layout';
import { Button } from 'framework/ui/mui-builder';
import RedirectButton from '../RedirectButton';

const ONE_CLICK_PASSWORD_FORM_SX = {
  display: 'inline-block',
  textAlign: 'center',
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '350px',
  '& .MuiFormControl-root': {
    marginBottom: 0,
  },
  '& legend.section-title': {
    width: '100%',
  },
  '& legend h4': {
    fontSize: '32px',
  },
  '& input[type="password"]': {
    minWidth: '270px',
  },
  '& .long-form-section': {
    border: 0,
    paddingBottom: '25px',
  },
};

const OneClickPasswordForm = ({ setPassword }: { setPassword: (passwordParam: string | null) => void }) => {
  let formPasswordValue: string;
  const submit = () => {
    setPassword(formPasswordValue);
  };

  const handleChange = (event: { target: { value: string } }) => {
    formPasswordValue = event.target.value;
  };
  const onEnterKeyPress = (event: { key: string }) => {
    if (event.key === 'Enter') {
      submit();
    }
  };

  return (
    <Box data-testid="oneclick-password-form" sx={ONE_CLICK_PASSWORD_FORM_SX}>
      <FormSection
        titleStyle={{
          display: 'flex',
          justifyContent: 'center',
        }}
        title="Welcome!"
        subtitle="Enter the One Click password"
      >
        <input
          className="form-control"
          style={{ border: '1px solid var(--mui-palette-common-commonInputBorder)' }}
          type="password"
          onChange={handleChange}
          onKeyPress={onEnterKeyPress}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
        <Button color="primary" type="button" onClick={submit} sx={{ marginTop: '18px', width: '100%' }}>
          Submit
        </Button>
      </FormSection>
      <RedirectButton />
    </Box>
  );
};

export default OneClickPasswordForm;
